import app from "./appUser/app.js";
import grantApp from "./appUser/grantApp.js";

export default {
    app,
    grantApp
};